import { usePathname, navigate } from "../../lib/router";
import ConsultasPorDiaPage from "./ConsultasPorDiaPage";

export default function MetricsRouter() {
  const path = usePathname();
  if (path === "/app/metrics" || path === "/app/metrics/consultas-por-dia") {
    return <ConsultasPorDiaPage />;
  }
  navigate("/app/metrics");
  return null;
}
